import { defineStore } from 'pinia'
import cims from "../cims";
import { nextTick } from 'vue'

export const useCitizensTrackingStore = defineStore('citizensTracking', {
  state: () => {
    return {
      showOnlyCompliantFields: Cookies.get('citizensShowOnlyCompliantFields') === 'true',
      bulkFormApplyButtonEnabled: false,
      currentFormDisplayed: Cookies.get('citizensCurrentFormDisplayed') || 'none',
      editModeClaimId: 0,
      filterSelectedClients: [],
    }
  },
  actions: {

    updateEditModeClaim (idClaim) {
      this.editModeClaimId = idClaim;
    },

    editModeClaimUpdated() {
      this.editModeClaimId = 0;
    },

    toggleFieldView () {
      this.showOnlyCompliantFields = !this.showOnlyCompliantFields;
      Cookies.set('citizensShowOnlyCompliantFields', this.showOnlyCompliantFields, { expires: 30 });
    },

    enableBulkApply() {
      this.bulkFormApplyButtonEnabled = true;
    },

    disableBulkApply() {
      this.bulkFormApplyButtonEnabled = false;
    },

    showFiltersForm() {
      this.currentFormDisplayed = 'filters';
      Cookies.set('citizensCurrentFormDisplayed', this.currentFormDisplayed, { expires: 30 });
      nextTick(() => {
        cims.addChosen();
      })
    },

    showBulkForm() {
      this.currentFormDisplayed = 'bulk';
      Cookies.set('citizensCurrentFormDisplayed', this.currentFormDisplayed, { expires: 30 });
    },

    hideHeaderForms() {
      this.currentFormDisplayed = 'none';
      Cookies.set('citizensCurrentFormDisplayed', this.currentFormDisplayed, { expires: 30 });
    },

    setFilterSelectedClients(clientIds) {
      this.filterSelectedClients = clientIds;
    }
  }
})
